var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavanderia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.8675C18.75 10.9308 17.4491 14.2659 14.8158 14.1986C12.1394 14.1307 10.0223 10.106 7.63158 10.2013C5.46416 10.2879 3.41776 14.1833 1 14.1986",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61538 4.19995H19.3846C19.7243 4.19995 20 4.47564 20 4.81534V19.5846C20 19.9243 19.7243 20.2 19.3846 20.2H4.61538C4.27569 20.2 4 19.9243 4 19.5846V4.81534C4 4.47564 4.27569 4.19995 4.61538 4.19995Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.19995C14.7613 7.19995 17 9.4387 17 12.2C17 14.9612 14.7613 17.2 12 17.2C9.23875 17.2 7 14.9612 7 12.2C7 9.4387 9.23875 7.19995 12 7.19995Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.19995C6.776 6.19995 7 6.42395 7 6.69995C7 6.97595 6.776 7.19995 6.5 7.19995C6.224 7.19995 6 6.97595 6 6.69995C6 6.42395 6.224 6.19995 6.5 6.19995Z",
    fill: "#2B363D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavanderia);
export default __webpack_public_path__ + "static/media/Lavanderia.6ba73096def07a86577b78a115f44305.svg";
export { ForwardRef as ReactComponent };